import { useConfirmationModal } from '@bridebook/aura';
import { useTranslation } from 'next-i18next';
import { useCreateMessageFlow } from './create-message-flow-context';

export const useConfirmExitFlowModal = () => {
  const { openModal } = useConfirmationModal();
  const { t } = useTranslation('inbox');
  const { forceCloseModal } = useCreateMessageFlow();

  const closeWithConfirmation = (onConfirm: () => void) => {
    openModal({
      title: t('guests.createMessageFlow.interceptModal.title'),
      text: t('guests.createMessageFlow.interceptModal.text'),
      primaryButtonText: t('guests.createMessageFlow.interceptModal.primaryButtonText'),
      onPrimaryButtonClick: () => {
        forceCloseModal();
        onConfirm();
      },
      secondaryButtonText: t('guests.createMessageFlow.interceptModal.secondaryButtonText'),
    });
  };

  return closeWithConfirmation;
};
